import { render, staticRenderFns } from "./FreightItemList.vue?vue&type=template&id=204d0982&scoped=true&"
import script from "./FreightItemList.vue?vue&type=script&lang=js&"
export * from "./FreightItemList.vue?vue&type=script&lang=js&"
import style0 from "./FreightItemList.vue?vue&type=style&index=0&id=204d0982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d0982",
  null
  
)

export default component.exports